module.exports = __webpack_public_path__ + "img/mercedes+benz.72eac017.png";